export function useLogger(logsEnabled) {
  function conditionalLog(message) {
    if (logsEnabled) {
      console.log(message);
    }
  }

  return { conditionalLog };
}
